import * as React from 'react';
import { twMerge } from 'tailwind-merge';

import { useAccessibilitySettings } from '@/hooks/useAccessibilitySettings';

type CallToActionProps = {
  items: {
    icon: React.ReactNode;
    title: string;
    description: React.ReactNode;
  }[];
  className?: string;
};

function Features({ items, className }: CallToActionProps) {
  const { useHighContrast } = useAccessibilitySettings();

  if (!Array.isArray(items) || items.length < 1) {
    return null;
  }

  return (
    <section
      className={twMerge(
        'pt-12 pb-12 lg:pt-20 lg:pb-20',
        useHighContrast ? 'bg-contrast-yellow text-black' : 'bg-[#f6f4df]',
        className
      )}
    >
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-20">
          {items.map(({ icon, title, description }) => (
            <div key={title} className="flex flex-col items-center">
              <div
                className={twMerge(
                  'h-[112px] w-[112px] rounded-full flex items-center justify-center',
                  useHighContrast ? 'bg-inherit' : 'bg-white'
                )}
              >
                {icon}
              </div>

              <h3 className="text-center mt-6 text-xl font-medium">{title}</h3>

              <p className="font-light mt-4">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
